import Modal from "common/components/Modal";
import Select from "common/components/Select";
import axios from "common/configs/axiosConfigs";
import { REFERRED_BY_OPTIONS } from "common/constants/enums";
import React, { useState } from "react";
import { toast } from "react-toastify";

const CreateContactForm = ({ onClose, isOpen, getContacts }) => {
  const companyId = JSON.parse(localStorage.getItem("user-auth"))?.company_id;

  const [formState, setFormState] = useState({ honorifics: "mr", referredBy: "Admin" });
  const handleInput = ({ target: { name, value } }) => {
    setFormState((prev) => ({ ...prev, [name]: value }));
  };
  const handleCreateContact = async (e) => {
    e?.preventDefault();
    try {
      const { data } = await axios.post("", {
        action: "addContact",
        companyId,
        ...formState,
      });
      if (data?.success) {
        getContacts(true);
        onClose();
        setFormState({ honorifics: "mr", referredBy: "Admin" });
        toast.success(data?.msg);
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };

  return (
    <Modal {...{ title: "Create Contact", onClose, isOpen }}>
      <form onSubmit={handleCreateContact}>
        <div className="step row gy-4">
          <div className="col-md-6">
            <div className="d-flex">
              <select
                name="honorifics"
                value={formState.honorifics}
                onChange={handleInput}
                className="form-select w-25 me-2"
                required
              >
                <option value="mr">Mr.</option>
                <option value="ms">Ms.</option>
                <option value="mrs">Mrs.</option>
              </select>
              <input
                type="text"
                name="firstName"
                value={formState.firstName}
                onChange={handleInput}
                className="form-control "
                placeholder="First name"
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <input
              type="text"
              name="lastName"
              value={formState.lastName}
              onChange={handleInput}
              className="form-control"
              placeholder="Last name"
              required
            />
          </div>
          <div className="col-md-6">
            <input
              type="tell"
              pattern="[0-9]{10}"
              name="phone"
              value={formState.phone}
              onChange={handleInput}
              className="form-control"
              placeholder="Phone number"
              required
            />
          </div>
          <div className="col-md-6">
            <input
              type="email"
              name="email"
              value={formState.email}
              onChange={handleInput}
              className="form-control"
              placeholder="Email address"
              required
            />
          </div>
          <div className="col-md-6">
            <Select
              options={REFERRED_BY_OPTIONS}
              name="referredBy"
              value={formState.referredBy}
              onChange={handleInput}
              placeholder="Referred by"
            />
          </div>
        </div>
        <div className="d-flex mb-n3 pt-3 mt-3 border-top justify-content-end">
          <button type="button" className="btn btn-light me-2">
            Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Create
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CreateContactForm;
